"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OMMStream = void 0;
const types_1 = require("@refinitiv-data/types");
const session_1 = require("../../session");
const omm_stream_1 = require("./omm-stream");
class OMMStream {
    static Definition(params) {
        return {
            getStream: (session = (0, session_1.getDefault)()) => {
                return new omm_stream_1.OMMStreamImpl(session, typeof params === 'string' ? { name: params } : params);
            },
        };
    }
}
exports.OMMStream = OMMStream;
OMMStream.Event = types_1.OMMStreamEvent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib21tLXN0cmVhbS5jbGFzcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9kZWxpdmVyeS9zdHJlYW0vb21tLXN0cmVhbS5jbGFzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxpREFBc0k7QUFFdEksMkNBQTJDO0FBQzNDLDZDQUE2QztBQUk3QyxNQUFhLFNBQVM7SUFLWCxNQUFNLENBQUMsVUFBVSxDQUFDLE1BQXVDO1FBQzVELE9BQU87WUFDSCxTQUFTLEVBQUUsQ0FBQyxVQUFtQixJQUFBLG9CQUFVLEdBQUUsRUFBYyxFQUFFO2dCQUN2RCxPQUFPLElBQUksMEJBQWEsQ0FBQyxPQUFPLEVBQUUsT0FBTyxNQUFNLEtBQUssUUFBUSxDQUFDLENBQUMsQ0FBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUM7WUFDOUYsQ0FBQztTQUNKLENBQUM7SUFDTixDQUFDOztBQVhMLDhCQVlDO0FBWGlCLGVBQUssR0FBRyxzQkFBYyxDQUFDIn0=